//import * as createjs from 'src/assets/js/createjs-touch.js';
import * as createjs from "createjs-module";
import { Messages } from 'src/app/shared/constant/messages';
import { UserPrefType } from 'src/app/shared/constant/canvasSymTypes';
import * as symConst from 'src/app/shared/constant/canvasSymTypes';
import {DT_TOOL_MULTI_LINE} from 'src/app/shared/constant/draw-tool-api'; 
import {
  startPen, endPen, disablePen, setPenTool,unDoPartialPenItem,resizePenBackground,finishMultiLine,
} from 'src/assets/js/cv-pen-tool.js';
import {
  DISPLAY_TYPE_GRID, DISPLAY_TYPE_LINE, IMAGE_TYPE_NONE, IMAGE_TYPE_PDF, IMAGE_TYPE_BITMAP, MathFileProbType, MathFileType,
  START_XPOS, START_YPOS, SIZE, FULL_CANVAS, UserInputLog, CanvasInput, LOG_MATHKEY, LOG_MOUSE, LOG_KEYBOARD,
  LOG_CNTR, CREATEJS_NAME_CARRY_BOX, ONE_PAGE_LENGTH, PAGE_MAX_PROB_START_POS, STAGE_MIN_WIDTH,
  FONT_INDEX, FONT_INDEX_MAX, FONT_INDEX_MIN, undoStackType, DISPLAY_TYPE_TEXT, UNDO_TYPE_WHITESPACE,
  MathFileProbType, MathFileType, STATE_DRAW_PEN_ITEM,
  CV_ANALYTICS_NONE, CV_ANALYTICS_BASIC, CV_ANALYTICS_ADVANCED,
} from 'src/app/shared/constant/drawConstants';
import {
  CvDrawingBoard, MathFileType, STATE_NORMAL, STATE_FILE_IMPORT, STATE_OPEN_FILE, STATE_IN_PASTE,
  STATE_INIT, STATE_DRAW_OVERLAY, STATE_CARRY_SYM, STATE_IN_ABC, STATE_IN_CLIPBOARD_SELECT, STATE_IN_PEN_TOOL,STATE_IN_DRAW_MULTI,
  STATE_IN_DRAG, STATE_IN_PROB_SCALE, STATE_ABC_WRAP, STATE_IN_IPAD_ABC, STATE_IN_GRID_FRACTION_NUM, STATE_IN_GRID_FRACTION_DEN,
  SCALE_INCREMENT, STATE_IN_WHITESPACE_ADD, STATE_CLIPBOARD_SELECT_ICON, MProbType, MLineType, MBranchType,
  SymbolType, SymbolLong, SymbolSimple, OVERLAY_TYPE_DIVIDE,
  STATE_VIEW_ONLY_FILE
} from 'src/assets/js/cv-classes.js';

import { setStageBackground,drawEmptyGrid,drawProbShapes, drawPageBreakLine,
        hideGridShape, showGridShape,hideGridShape,drawCursor,handleStageMouse, drawUpdatedOverlay, 
        makeProbSelected,makeProbSelectedAt,ifIpadAddStageContainer,setClipFlags,setSymColor,
        copySelectTimer } from 'src/assets/js/cv-graphics-mouse.js';
import {startMProb, drawOneSym,resizeProbGridChange,directionArrowMove,
        changeToProb,deleteProb} from 'src/assets/js/cv-layout-shared.js';
import {newGridSym,moveYGridText,handleDeleteFromGrid,newLineSymGrid,newDivSymGrid,
      newCrossOff,newCarry,newReverseGridSym} from 'src/assets/js/cv-grid-entry.js';
import { cvStartNewFile, cvHandleGetFileData , cvOpenFile,cvUndoReset,saveForCopyDuplicate,
        drawFromSaveFile,setLastProbActive} from 'src/assets/js/cv-file.js';
import { getSymFont,findProbEndX, findProbEndY, findProbLineY, findProbSymX,pushUndoObj,findBranchClickIndex,
        findLastProb,resetTreeXYPosAndCursor, resetTreeProbHeight,resetMoveTreeProbHeight,
      showCursor, hideCursor, doStageUpdate,findLastMatchedProb} from 'src/assets/js/cv-helpers.js';
import { displayIpadABC,endABCText,pressedKey,handleTextBox} from 'src/assets/js/cv-text.js';
import { deleteFromTree, newTreeSym,doAdvance,doControlCompete, doControlComplete,
        newTreeCrossOff,newTreeCarry,writeCalcBranchSym} from 'src/assets/js/cv-line-entry.js';
import {selectWhiteSpace, cancelWhiteSpaceAdd,undoWhiteSpaceAdd, redoWhiteSpaceAdd} from 'src/assets/js/cv-whitespace.js';



//  declare a global variable db object, defined in cv-classes, to contain  all the 
//  variables that define the current state and values on the canvas drawing board

export var db = new CvDrawingBoard();


/*** 
 Get canvas loaded at the right time, called by code outside of canvas segment
 Initialize the stage, the canvas segment internal data structures (named db),
 and enable touch in createjs

 ***/
export let stage;
export function loadCanvas(inIpad) {
  //console.log("load canvas");

  stage = new createjs.Stage("drawingboard");
  //db.pen = null; 
 
  //inIpad = true;
  
  // Set up the grid sizes based on current user selection.  For now always use FONT_SIZE_LG
  db.initSize(symConst.FONT_SIZE_LG);
  db.newInit = true;
 
  // do createjs call needed to enable touch on touch systems
  let touchS = createjs.Touch.isSupported();
  if (touchS) {
    createjs.Touch.enable(stage,false,true);  // enable touch events
    //db.inIpad = inIpad;
  }
  db.inIpad = inIpad; 

  window.addEventListener('load', function() {
    const canvas = document.getElementById('drawingboard'); 
  canvas.addEventListener('contextmenu', function(event) {
    event.preventDefault();
  });
  });
  

}

/**
 * function notifySideBoardLev3Mode is called from the mouse handler routines, 
 * when the user is in level 3, and clicks on a prior problem that switches the grid/line mode
 * 
 * It receives in the display type being switched too.
 * modeType is set to equal a keyID value corresponding to the display type being switched too
 */

export function notifySideboardLev3Mode(displayType) {

  let modeType = (displayType == DISPLAY_TYPE_GRID) ? symConst.CV_CNTL_NEW_GRID_PROBLEM : symConst.CV_CNTL_NEW_PROBLEM;
  
  // make sure db flag set correctly for call cases
  if (displayType == DISPLAY_TYPE_GRID) {
    db.lev3UseGrid = true;
  }
  db.lev3UseGrid = (displayType == DISPLAY_TYPE_GRID) ? true : false;
 
  // notify sideboard in angular section
  window.displayMode.process.publicFunc(modeType);
}

// canvas will call this function at the end of processing an undo which requires
// sideboard to switch from displaying draw tool to displaying math keys
export function notifySideboardDrawToMath() {

  //console.log("CALL Angular draw to math");
  if (window.displayMode && window.displayMode.process) {
    window?.displayMode?.process?.publicFunc(symConst.CV_CNTL_END_DRAW_TOOL,db.lev3UseGrid);
  }
}

// canvas will call this function at the end of processing an undo which requires
// sideboard to switch from displaying math key to displaying draw tool
export function notifySideboardMathToDraw() {
   //console.log("CALL Angular math to draw");
   if (window.displayMode && window.displayMode.process) {
    window?.displayMode?.process?.publicFunc(symConst.CV_CNTL_START_DRAW_TOOL,db.lev3UseGrid);
  }
}


  // stage ticker, added for drag/drop, not called current
function tick(e) {
    doStageUpdate();
}


// Here is a definition for the canvas routine to call from draw Tool
export function cvDrawTool(drawToolObj) {
   setPenTool(drawToolObj);
}

// Here is the definition for the canvas routine to call from the graph Tool
export function cvNewGraphProb(GraphProbObj)  {
  //console.log(GraphProbObj);
}


/*** 
 function cvGetFileDataToSave() is called from the routines managing the menu bar
 when the user selects save or there is an autosave
 null is returned if there have not been any changes to user data
 since the last file save action
***/
export function cvGetFileDataToSave(getUserTrace,  doUndoPush) { 
  
  let jsonFile = "";
  let undoObj = null;

  if (getUserTrace) {     
    jsonFile= JSON.stringify(db.userLog);
  }
  else {
    if (db.fileChanged || db.mProb.length == 0 ) { 
      if (db.mProb.length != 0 || db.penItemList.length > 0) {
        undoObj = new undoStackType();
      }
      db.mathFile = cvHandleGetFileData(undoObj); 

      /** 
      //  return the user log file as temporary advanced analytics
      if (db.analytics == CV_ANALYTICS_ADVANCED) {
        db.mathFile.userLog = db.userLog;
        db.mathFile.timeSpent = 40;        // active time spent in minutes - initial temp value set for angular teting
        db.mathFile.excessErrors = 10;
      }
      else if (db.analytics == CV_ANALYTICS_BASIC)  {
        db.mathFile.timeSpent = 30;        // active time spent in minutes - initial temp value set for angular teting
        db.mathFile.excessErrors = 3;
      }
      **/

      jsonFile = JSON.stringify(db.mathFile);
     
      db.fileChanged = false;
      if (doUndoPush && undoObj != null) {
        pushUndoObj(db.mathFile,undoObj);
      }
    }
    else {
      jsonFile = null;
   }

  }

 
  return jsonFile;
}

/**
 * function cvGetFileData returns the current file as a json string without clearing db.fileChanged,
 * so it can be called at any time without affecting the next save
 */
export function cvGetFileData() {
  return JSON.stringify(cvHandleGetFileData(null));
}

/**
 * function cvGetDataUndoPush uses some of the same routines as above, but is
 * only for creating an undo stack object, so it doesn't change db.fileChanged 
 * Note that whitespace changes undo objects are done differently and are in cv-whitespace.js
 */

export function cvGetDataUndoPush() {

  // don't do undo pushes when writing from a saved file or undo
  if (db.state != STATE_OPEN_FILE) {
    let undoObj = new undoStackType();
    db.mathFile = cvHandleGetFileData(undoObj); 
    //console.log("PUSH UNDO", db.mathFile);
    pushUndoObj(db.mathFile,undoObj);
  }

}



/***
  Function cNewFile is called from routines managing the menu bar when
  the new file icon or open file icon is clicked by the user and at the start of the 
  app running.  It clears any previous data from the screen, initializes data structure
  display a passed in image file,and if a json File is passed, then redraws the canvas
  display based on the contents of jsonFile
***/



export function cvNewFile(mathLevel,importURL,bitmaps,jsonFile,fromCancel, viewOnly, analytics) { 
 
    db.mathLevel = mathLevel;
    
    if (jsonFile != null) {           // a jsonFile indicates that this was an open file request
 
      let mathFile = JSON.parse(jsonFile);
      mathFile.mathLevel = mathLevel;
      db.imageScale = mathFile.imageScale;
      cvStartNewFile(mathLevel,importURL,bitmaps,fromCancel);
      db.inOpenViewOnly = viewOnly;
      db.mathFile = mathFile;
      db.openedFile = mathFile;
      cvOpenFile(db.mathFile);
      }
    else {
      db.imageScale = 1;
      cvStartNewFile(mathLevel,importURL,bitmaps,fromCancel);
      db.inOpenViewOnly = viewOnly;
    }
    
    db.analytics = analytics;

    // set the stage background last, so that the canvas length can be matched
    // the background is needed because clicks are only recorded on top of objects
    setStageBackground(); 
    // set a listener on the stage background container, as a substitute for stage clicks and also
    // in ipad this will be used to create drag substitutes
    handleStageMouse();
    
  
    // reset the Amode flag when canvas has been reloaded, which is after refresh or set math level, but not
    // after a new file open without these actions, to keep in sync with sideboard
    if (db.newInit) {  // set by prefs now
      //db.isBranchAMode = (mathLevel == 3); // single-digit entry is default for level 3, NA to levels 1,2
    } 
    db.newInit = false;
    if (db.inOpenViewOnly) {
     
      // push current mathFile to the undo stack on a view only, so it can be retrieved
      // if switch to edit mode later
      if (db.mathFile != null) {
        let undoObj = new undoStackType();
        pushUndoObj(db.mathFile,undoObj);
      }

      // change the state if no import file.  Otherwise leave it since it has to get
      // changed after async file load finishes
      if (!(importURL || bitmaps)) {
        db.inOpenViewOnly = false;
        db.state = STATE_VIEW_ONLY_FILE;
      }
    }
    return(true);
}


// function resetForChangeViewOnlyToEdi is called when a file is changed from view only
// to editable.  It uses the last mathFile saved to the undo stack to reset and recreate db structures
// and redraw the canvas, in order to easily get all the event watchers running

function resetForChangeViewOnlyToEdit() { 

  let mathFile;
  let undoObj;
  if (db.undoStack.length > 0) {
    undoObj = db.undoStack[db.undoStack.length-1];
    mathFile = undoObj.mathFile;
    
  }
  
    ifIpadAddStageContainer();
    cvUndoReset(mathFile);  

    if (mathFile != null) {
      cvOpenFile(mathFile,true,undoObj);
      db.pIndex = db.mProb.length-1;
      setLastProbActive();
    }
    else {
      db.state = STATE_INIT;
    }
    
    setStageBackground(); 
    handleStageMouse();

}
/** 
 * function undoFromMathFileObj does an undo action, by popping the last math file structure from the undo list,
 * and resetting the db to this format, using routines from cv-File
 */

/***
 * function undoRedo processes an undo, or redo if isRedo = true, by pulling
 * prior math files and commands off the undo/redo stacks
 */
function undoRedo(isRedo,isRedraw) {

 
  //console.log("in undoRedo", db.state, db.inPen, db.undoStack); 

  // in pen multiLine is the only tool involving multiple clicks.  If undo from keyboard then, finish the object without last drag
  if (db.inPen && db.penItemList.length > 0 && db.penItemList[db.curPenIndex].dt.toolType == DT_TOOL_MULTI_LINE
    && db.state == STATE_IN_DRAW_MULTI) {
      finishMultiLine();
      return;
  }
  else if (db.state == STATE_IN_DRAW_MULTI) {
    console.log("ERROR STATE");
  }

  // if within the UI for adding a whitespace, then just cancel the whitespace add
  if (db.state == STATE_IN_WHITESPACE_ADD) {
    cancelWhiteSpaceAdd();
    return;
  }

  if (db.state == STATE_IN_CLIPBOARD_SELECT) {
    clearProbState(true,true);
    return;
  }

  clearProbState();

  let mathFile;
  let undoObj = null;
  let skipNoFile = false;
  db.inUndo = true;
  let wasInPen= db.inPen;
  let lastUndo;
  let lastInPen;
  let usingOriginal = false;
  


  // the top file on the undo stack for the first undo will be the current state, so
  // remove that and put it on the redo stack
  if (isRedo) {
    if (db.redoStack.length != 0) {
      undoObj = db.redoStack.pop();
      mathFile = undoObj.mathFile;
      if (undoObj.type == UNDO_TYPE_WHITESPACE) {
          redoWhiteSpaceAdd(undoObj);
        skipNoFile = true;
      } 
      else {
        db.undoStack.push(undoObj);
      }
    }
    else {
      skipNoFile = true;
      db.inUndo = false;
    }
  }
  else if (db.undoStack.length > 0 || isRedraw) {

    // the isRedraw flag is used to only redraw the exisiting canvas, when a user changes font colors/traits
    // nothing is removed from the undo stack
    
    if (!isRedraw) {
      lastUndo = db.undoStack.pop();
  
      lastInPen = lastUndo.state == STATE_IN_PEN_TOOL;
    
      // handle add whitespace undo differently - these can't be redone, and also the whitespace splits are on the current, last
      // undo record
      if (lastUndo.type == UNDO_TYPE_WHITESPACE) {
        undoWhiteSpaceAdd(lastUndo);
        skipNoFile = true;
      } 
    
      db.redoStack.push(lastUndo);
    }
       
    // find the right mathFile to use to rebuild, either on undo stack, or if user has undone everything
    // then go back to the opened file or initial statge
    if (db.undoStack.length > 0) {
      undoObj = db.undoStack[db.undoStack.length-1];
      
      mathFile = undoObj.mathFile;
      //console.log("in undo2", undoObj,mathFile);
    }
    else if (db.openedFile != null) {
      mathFile = db.openedFile;
      usingOriginal = true;
    }
    else {
      mathFile = null;
    }

  }
  else {
    // if there were no undo objects tell user message
    skipNoFile = true;
    if (!isRedraw) {
      if (db.inPen) { 
        window.translateService.get('ERROR.cvNoUndoPen').subscribe(translatedValue => {
          window.toastService.showError(translatedValue);
        });
      }
      else {
        window.translateService.get('ERROR.cvNoUndoData').subscribe(translatedValue => {
          window.toastService.showError(translatedValue);
        })
      }
    }
    return;
  }
  

  //console.log("In undo", mathFile);
  // Update db.pen based on the last state in the undo stack or redo stack
  if (mathFile && mathFile.savedPenItem && mathFile.savedPenItem.length > 0) {
    db.pen = Object.assign({}, mathFile.savedPenItem[mathFile.savedPenItem.length - 1].dt);
    ///console.log("IN UNDO",db.pen.drawMode, db.pen );

    if (window.drawToolComponent) {
      window.drawToolComponent.ngZone.run(() => {
      window.drawToolComponent.resetPenStates();
    });
    }
  }


  // do those actions from an new file needed to reset the drawing board, but keep the existing image file
  if (!skipNoFile) {
    ifIpadAddStageContainer();
    cvUndoReset(mathFile);  

    if (mathFile != null) {
      cvOpenFile(mathFile,true,undoObj);
    }
    else {
      db.state = STATE_INIT;
    }
    if (undoObj != null && undoObj.state == STATE_IN_PEN_TOOL) {
      db.inPen = true;
      startPen();
      hideCursor();
    }
    
    setStageBackground(); 
    handleStageMouse();

    if (undoObj != null && db.mProb.length > 0 ) {
     
      // check for and deal with problem type switches in level 3
      let newType = db.mProb[undoObj.pIndex].displayType; 
      db.displayType = newType;
         
      if (newType == DISPLAY_TYPE_LINE) {
        db.curProb = db.mProb[undoObj.pIndex];
        db.curLine = db.curProb.line[undoObj.lIndex];
        db.curBranch = db.curLine;

        let sIndexBranch = db.curLine.sIndex;
        let branchIndex; 
        
        for (let k = undoObj.branchList.length-1; k >= 0; k--) {
          sIndexBranch = undoObj.branchList[k].parentIndex;
          branchIndex = undoObj.branchList[k].branchIndex;
          // if undo stack error just skip setting this
          if (db.curBranch.sym[sIndexBranch] != null && db.curBranch.sym[sIndexBranch].branch != null) {  
            
            db.curBranch = db.curBranch.sym[sIndexBranch].branch[branchIndex];
          }
        }
        
        db.curBranch.sIndex = undoObj.sIndex;
        if (undoObj.pIndex >= db.mProb.length) {
          console.log("error pIndex", undoObj, db.curProb, db);       
         }
        
        makeProbSelectedAt(undoObj.pIndex,undoObj.lIndex,db.curBranch.sIndex);
               
        }
        
      
      else {
        if (undoObj.pIndex >= db.mProb.length) {
          console.log("error pIndex", undoObj, db.curProb, db);       
         }

        makeProbSelectedAt(undoObj.pIndex,undoObj.lIndex,undoObj.sIndex);

        // check if last within a grid fraction, and if so, then move back into it and move cursor back
        if (undoObj.curProbFracState != STATE_NORMAL) {
          db.curProb.fracState = undoObj.curProbFracState;
          db.xpos -= db.curProb.gridW;
          drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
        }
      }

    
    }
    else if (mathFile != null) {

    
      db.pIndex = findLastMatchedProb();
      if (db.pIndex >= 0) {
         makeProbSelected(db.pIndex);
      }
      else {
        doNewProblem(); 
      }
     
    }
    
    if ((undoObj != null && undoObj.state != STATE_IN_PEN_TOOL && wasInPen) ||
        (undoObj == null && lastInPen)) {
      notifySideboardDrawToMath();
    }
    else if (undoObj != null && undoObj.state == STATE_IN_PEN_TOOL && !wasInPen) {
      notifySideboardMathToDraw();
    }
    else if (undoObj != null && undoObj.state == STATE_IN_PEN_TOOL) {
      hideCursor();
    }
    
    if ((undoObj != null && !undoObj.state != STATE_IN_PEN_TOOL) &&
        (db.mathLevel == 3 && db.curProb != null) &&
        ((db.lev3UseGrid && db.curProb.displayType == DISPLAY_TYPE_LINE) ||
         !db.lev3UseGrid && db.curProb.displayType == DISPLAY_TYPE_GRID)) {
        notifySideboardLev3Mode(db.curProb.displayType);
    } 
    doStageUpdate();
  }
 //console.log("DONE undoredo", undoObj.state, wasInPen);
}


/***
 * function destroyCanvas is called when the application is being closed or the stage is destroyed such as for an 
 * open file to clear touch enable and release stage elements
 */
export function destroyCanvas() {
   
  if (stage) {
    stage.removeAllEventListeners();
    stage.removeAllChildren();
    //db = null;
    if ( createjs.Touch.isSupported() ) {
      createjs.Touch.disable(stage);
    }
  }
}
/*** 
 function cvUserPrefs is called by a routine managing the menu bar to 
  update the values found under the user preferences menu
***/
export function cvUserPrefs(newUserPrefs) {

  let resize = false;
  let redraw = false;
  
  if (typeof newUserPrefs != "object") {
    newUserPrefs = new UserPrefType();
  }
 
  if (db.userPrefs == null) {
    db.userPrefs  = new UserPrefType(newUserPrefs.userId);
  }
  else if (newUserPrefs.userId != db.userPrefs.userId) {
    db.userPrefs.userID = newUserPrefs.userId;
  }
  // if the same user then that means this call is from userPrefs, check for changes needing a redraw then
  else if ((db.userPrefs.cvMainColor != newUserPrefs.cvMainColor) ||
    (db.userPrefs.cvEqualsColor != newUserPrefs.cvEqualsColor) ||
    (db.userPrefs.cvOperatorsColor != newUserPrefs.cvOperatorsColor) ||
    (db.userPrefs.cvTextColor != newUserPrefs.cvTextColor) ||
    (db.userPrefs.gridLineIndex != newUserPrefs.gridLineIndex-1) ||
    (db.userPrefs.useBoldMathDisplay != newUserPrefs.useBoldMathDisplay) ||
    (db.userPrefs.backgroundColor != newUserPrefs.backgroundColor)) {
     redraw = true;
    }

  db.userPrefs.isDyslexic = (newUserPrefs.isDyslexic)? newUserPrefs.isDyslexic: false;
  //db.userPrefs.A_AA_status = newUserPrefs.A_AA_status;
  db.isBranchAMode = (db.userPrefs.A_AA_status == symConst.CV_CNTL_A); 
  db.userPrefs.colorEquals = (newUserPrefs.displayEqualInColor)? newUserPrefs.displayEqualInColor: false;
  db.userPrefs.alignEqualSign  = (newUserPrefs.alignEqualSign) ? newUserPrefs.alignEqualSign : false;
  db.userPrefs.isDoubleClick  = newUserPrefs.isDoubleClick || false;
  // Cursor indexes receive start at 1, so subtract one to give an array index
  if (db.userPrefs.cursorColorIndex != newUserPrefs.cursorColorIndex-1) {
    db.userPrefs.cursorColorIndex = newUserPrefs.cursorColorIndex-1;
   
    if (db.curProb != null && (db.curProb.displayType == DISPLAY_TYPE_GRID ||
                               db.curProb.displayType == DISPLAY_TYPE_LINE)) {
   
    drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
    }
  }

 
  // insert other changes for font spacing here 
  if (db.userPrefs.fontSpacing != newUserPrefs.fontSpacing)  {
    db.userPrefs.fontSpacing = newUserPrefs.fontSpacing;
  }
  
  db.userPrefs.cvMainColor = (newUserPrefs.cvMainColor)? newUserPrefs.cvMainColor: 'black';
  db.userPrefs.cvOperatorsColor  = (newUserPrefs.cvOperatorsColor) ? newUserPrefs.cvOperatorsColor : 'black';
  db.userPrefs.cvEqualsColor  = (newUserPrefs.cvEqualsColor) ? newUserPrefs.cvEqualsColor : 'black';
  db.userPrefs.cvTextColor  = (newUserPrefs.cvTextColor) ? newUserPrefs.cvTextColor : 'black';
  db.userPrefs.useBoldMathDisplay  = (newUserPrefs.useBoldMathDisplay) ? newUserPrefs.useBoldMathDisplay : false;
  //console.log(db.userPrefs.useBoldMathDisplay, newUserPrefs, db.userPrefs);

  db.userPrefs.gridLineIndex = newUserPrefs.gridLineIndex-1;

  
  if (newUserPrefs.backgroundColor != db.userPrefs.backgroundColor && newUserPrefs.backgroundColor != undefined) {
    db.userPrefs.backgroundColor = newUserPrefs.backgroundColor;
    //db.userPrefs.cvMainColor = "white";
    
    if (db.stageBackground != null) {
      db.stageBackground.graphics.clear().beginFill(db.userPrefs.backgroundColor);   
      //db.stageBackground.alpha = .8;          
      db.stageBackground.graphics.rect(0,0,stage.canvas.width/stage.scaleX,stage.canvas.height/stage.scaleY); 
    }    
      
  }

  // canvas uses gridlineIndex 1 less then passed from html
  if (db.userPrefs.gridLineIndex != newUserPrefs.gridLineIndex-1) {
    db.userPrefs.gridLineIndex = newUserPrefs.gridLineIndex-1;
  }
  
  // receive in font sizes from user prefs from 1-4, adjust to range 0-3 and then look the size 
  // using font_index.  Note db.fontIndex is a range 0-3, while db.fontSize is the actual font size
  if ( FONT_INDEX[newUserPrefs.fontSize-1] != db.fontIndex) {  // change font size due to user preferences update
    resize = true;
  }
  db.fontIndex= FONT_INDEX[newUserPrefs.fontSize-1];
  db.initSize(db.fontIndex);
  // save the prefs font index seperately to distinguish it from font changes inside a file
  db.prefFont = db.fontIndex; 
  
 
  if (resize) {
    resizeProbGridChange();
  }
  
  // check if the grid visibility changed
  if (newUserPrefs.hideDisplayGrid != db.userPrefs.hideDisplayGrid) {
    db.userPrefs.hideDisplayGrid = (newUserPrefs.hideDisplayGrid) ? newUserPrefs.hideDisplayGrid: false;

     // if not an new empty file and grid type, then swap the current problem grid visibility
    if (db.curProb != null && (db.curProb.displayType == DISPLAY_TYPE_GRID)) {    
      if (!db.userPrefs.hideDisplayGrid) {      
        if (db.curProb.gridShape != null) {
          db.curContainer.removeChild(db.curProb.gridShape);   // delete prior grid shape if there is one
        }        
        drawEmptyGrid(0,0,db.curProb.width,db.curProb.line.length);
      }
      else {
        hideGridShape(db.curProb);
      }
    }
  }

  if (redraw) {
    undoRedo(false,true);
  }

  // call angular to set level 3 state to fix issue if not at start of program
  if (db.pIndex > -1 && db.state != STATE_INIT && db.mathLevel == 3 && db.lev3UseGrid) {
    notifySideboardLev3Mode(DISPLAY_TYPE_GRID);

  }

  doStageUpdate();
}

// routines for the outside UI routines to call for print or export if need to 
// hide or show page breaks
export function hidePageBreaks() {
  if (db.pageBreakContainer != null) {
    db.pageBreakContainer.visible = false;
  }
  if (db.curProb != null) {
    hideGridShape(db.curProb);
  }
  drawCursor();

  if (db.inIpad) {
    db.ipadDragX = db.stageDragContainer.x;
    db.ipadDragY = db.stageDragContainer.y;
    db.stageDragContainer.x = db.stageDragContainer.y = 0;
  }
  doStageUpdate();
  return(db.pageCount);
}

export function showPageBreaks() {

  if (db.inIpad) {
    db.stageDragContainer.x = db.ipadDragX;
    db.stageDragContainer.y = db.ipadDragY;
    db.ipadDragX = db.ipadDragY = 0;
  }
  if (db.pageBreakContainer != null) {
    db.pageBreakContainer.visible = true;
  }
  if (db.curProb != null) {
    showGridShape(db.curProb);
    drawCursor(db.xpos-db.curProb.halfGW,db.ypos-db.curProb.halfGH);
  }
 
  doStageUpdate();
}
/*** 
  Function draw is main function of drawing board, called from within drawing-board.component.
  It is called every time a user clicks a math key button (except for abc which has special handling in cv-text.js)
  It accepts as parameters 
    keyID: string contant representing the symbol that was type, in symConstTypes.ts
    groupCode: A group code which categorizes the display behavior of this symbol
    typeCode: A type code that groups together similiar types of KeyIDs
  ***/
export function draw(keyID, groupCode, typeCode) {

  //console.log("TEST QA", keyID, groupCode, typeCode);
  
 
    //console.log(window.navigator['msPointerEnabled'] , window.navigator["pointerEnabled"] , window.MSPointerEvent, window.PointerEvent)
  // throw out any keyboard control entries if they are the first thing a user types
  // to prevent possible empty problems or empty files in this case
  if ((db.state == STATE_INIT) && (typeCode === symConst.CV_ABC_TYPE) && (keyID.length >1) ||
       db.state == STATE_IN_WHITESPACE_ADD ) {
    return;
  }

  // accept no input when in view only file mode
  if (db.state == STATE_VIEW_ONLY_FILE) { 
      return;
    }

  // if in pen, throw out and keyboard keys and send user error message
  if (db.inPen) {
    window.translateService.get('ERROR.cvPenNoKeyboardEntry').subscribe(translatedValue => {
      window.toastService.showError(translatedValue);
      return;
    })
  }

  if (db.state == STATE_IN_CLIPBOARD_SELECT || db.state == STATE_CLIPBOARD_SELECT_ICON) {
    // clear only clipboard state and not problem state
    clearProbState(false,true);
  }

  if (keyID == symConst.KEY_ID_X_SQR || keyID == symConst.KEY_ID_Y_SQR) {
    typeCode = symConst.CV_VAR_SQR_TYPE;
  }
  
  if (typeCode == symConst.CV_DERIVATIVE_TYPE && groupCode == symConst.CV_BRANCHING_GRP) {
    writeCalcBranchSym(keyID, groupCode, typeCode);
    return;
  }

 
  //clear redo stack when get first entry after an undo, but not during the undo redraws
  if (db.inUndo && db.state != STATE_OPEN_FILE) {
    db.redoStack.length = 0;
    db.inUndo = false;
  }

 
  if (keyID != symConst.CV_EMPTY_SYM && db.userLog != null) {
    let logInput = new CanvasInput(LOG_MATHKEY,keyID);
    db.userLog.input.push(logInput);
    db.fileChanged = true;
  }
 
  
  db.fileChanged = true;
  let doCarry = false;

  // If this is the first time user typed a symbol, then initialize a new problem
  if (db.state == STATE_INIT || db.curProb == null) {
    db.state = STATE_NORMAL;
    startMProb(db.displayType);
  }
  

  switch (db.probState) {
    case STATE_DRAW_OVERLAY:
      if (db.curOverlay != null) {
     //console.log("at state", db.curOverlay,db.curOverlay.lIndex,db.curProb.lIndex);
      }
      // figure out if the current position is within a division overlay and new symbol is type that leaves division active
      if ((db.curOverlay != null && db.curOverlay.type == OVERLAY_TYPE_DIVIDE) && (db.curOverlay.lIndex == db.curProb.lIndex) 
           && (groupCode == symConst.CV_SIMPLE_GRP || groupCode == symConst.CV_BRACKET_GRP)) {
         
            if (db.curLine.sIndex == db.curOverlay.end-1) {
              db.curOverlay.end++;
              // drawDivOverlayUpdate(db.curLine.overlay);
              drawUpdatedOverlay(db.curOverlay,true);  // true says to stay active, and redraws the divide overlay one grid longer
          }
      }
      // otherwise, must either be in line segment, or else in division with new sym added 
      // that would cause divide to end, so unselect/end overlay 
      else { 
        db.probState = STATE_NORMAL;
        //drawUpdatedOverlay(db.curOverlay,false);
      }
      break;
      case STATE_CARRY_SYM:
    
        if (groupCode == symConst.CV_SIMPLE_GRP) { 
          doCarry = true;
        }
        else {
          clearProbState();
        }
        break;
      case STATE_IN_PROB_SCALE:
        clearProbState();
        break;
      case STATE_IN_IPAD_ABC:
        clearProbState();
        break;

    // other states will be added for specific symbol types
    default:
      break;
  }

  if ((typeCode === symConst.CV_ABC_TYPE) && (keyID.length >1)) {  
    checkKeyboardCntl(keyID);
  }
  else {
     
      // if in text type problem, create a new problem since can't add text to these
      if (db.curProb.displayType == DISPLAY_TYPE_TEXT) {
        let lastpIndex = findLastProb();
        if (lastpIndex > -1) {
          db.ypos += db.curProb.gridH*2;
          checkPosForPageAdd()
          startMProb(db.displayType);
        }
      }

    // For math levels 1 and 2, use grid-type problems
    //if (db.mathLevel == 1 || db.mathLevel == 2 || db.curProb.displayType == DISPLAY_TYPE_GRID) {
    if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
      // check if called keyboard control character, if so redirect those
      // this code is received for keyboard keys not abc keys
      // if within grid fraction, then do nothing for line segments, division, and crossoff
     
      switch (typeCode) {
        case symConst.CV_LINE_TYPE:
          if (db.curProb.width > 0 && db.curProb.fracState == STATE_NORMAL) {
            newLineSymGrid(keyID);
          }
          break;
        case symConst.CV_DIV_SQRT_TYPE:
          if (db.curProb.fracState == STATE_NORMAL) {
            newDivSymGrid(keyID);
          }
          break;
        case symConst.CV_CROSSOFF_TYPE:
          if (db.curProb.fracState == STATE_NORMAL) {
            // For crossoffs, first check that there is a symbol in the space to write over
            // unlike all other symbols, crossoff will go over the space in the cursor
            if (db.curLine.sym[db.curLine.sIndex+1] == null) { 
              draw(symConst.KEY_ID_SPACE, symConst.CV_SIMPLE_GRP, symConst.CV_NUM_TYPE);
              db.curLine.sIndex--;
              db.xpos -= db.curProb.gridW;
            }
              newCrossOff(keyID);
                
          }
          break;
        default:
          if (doCarry) {
            newCarry(keyID);
          }
          else {
              newGridSym(keyID, groupCode, typeCode);
          }
          break;
      }
    } 
  

    
    else {      

      switch (typeCode) {
    
      // CV_ABC_TYPE symbols are from keys typed in the keyboard, not during an abc event
      // Check these for keyboard control keys as these should be either be ignored or
      // reassigned to cvControl as opposed to being displayed
        case symConst.CV_ABC_TYPE:  
          if (keyID.length >1) {    // control keys will produce longer than one character keyIDs
          checkKeyboardCntl(keyID);
          }  
          else {        // regular 1 character symbols should get displayed in the usual way
          newTreeSym(keyID, groupCode, typeCode);
          }  
          break;
        
        case symConst.CV_CROSSOFF_TYPE:
        
          // only process cross-offs over digits for now
          if (db.curBranch.sym[db.curBranch.sIndex+1] != null && 
            db.curBranch.sym[db.curBranch.sIndex+1].groupCode != symConst.CV_BRANCHING_GRP) {
              newTreeCrossOff(keyID);
            }
          break;
        default:
          if (doCarry) {
            newTreeCarry(keyID);
          }
          else {
          // draw the passed symbol on the canvas drawingboard

          // if it is a branching calculus symbol, then break apart to call draw routine as a fraction, top and bottom
          if (typeCode == symConst.CV_DERIVATIVE_TYPE && groupCode == symConst.CV_BRANCHING_GRP) {
              writeCalcBranchSym(keyID, groupCode, typeCode);
            }
            else {
              newTreeSym(keyID, groupCode, typeCode);
            }
          }
          break;
      }
    }
  }
  // check the position of the symbol compared to db.lastCanvasY, to keep track of the end of canvas used
  // for whitespace canvas length management
  if (db.ypos > db.lastCanvasY) {
    db.lastCanvasY = db.ypos;
  }
  if (db.state != STATE_OPEN_FILE) {
    let undoObj = new undoStackType();
    db.mathFile = cvHandleGetFileData(undoObj); 
    pushUndoObj(db.mathFile,undoObj);
  }
  
}

// function clearProbState is called if the user clicks on a different problem or area in order to clear states
// associated with special symbols and unhighling/activate these symbols
export function clearProbState(leaveScale, onlyClipboard) {

  if (db.state == STATE_IN_CLIPBOARD_SELECT) {

    // reset cursor if from menu click - neccessary this way due to createjs cursor bug
    if (db.selectionArea.resizeDot != null)  {
      let canvas = document.getElementById('drawingboard');
      canvas.classList.remove("ew-resize-cursor");
      canvas.classList.add("default-cursor");
    }

    db.state = STATE_NORMAL;
    if (db.selectionArea != null && db.selectionArea.box != null) {
      db.selectionArea.parent.removeChild(db.selectionArea.box, db.selectionArea.resizeDot);
      db.selectionArea = null; 
    } 
    //clear all they symbol flags and set them to black
    for (let i  = 0; i <= db.curLine.sym.length-1 ; i++) {
      // call setClipFlags to reset the clipboard flags of symbols within a branch
    
      if (db.curLine.sym[i].groupCode == symConst.CV_BRANCHING_GRP) {
        setClipFlags(db.curLine.sym[i],false,true);
      }
      // call routine to set colors - this also deals with fraction lines and sqrt colors
      if (db.curLine.sym[i].displayText != null && db.curLine.sym[i].isSelected) {    
        setSymColor(db.curLine.sym[i],db.curLine,"black",false);
      }
      db.curLine.sym[i].isSelected = false;
      db.curLine.sym[i].clipOffset = -1;
    
    }

  }
  if (!onlyClipboard) {
    switch (db.probState) {
      case STATE_DRAW_OVERLAY:
       
        if (db.curOverlay != null ) {
          
          if (db.curOverlay.myProb != db.curProb) {
            drawUpdatedOverlay(db.curOverlay,false);  // redraws the divide overlay unselected
            db.probState = STATE_NORMAL; // BUG CHANGE
          }
        }
        break;
      case STATE_CARRY_SYM:
        
        if (db.curCrossOff != null) {
          let carryBox = db.curCrossOff.getChildByName(CREATEJS_NAME_CARRY_BOX);
          
          db.curCrossOff.removeChild(carryBox);
          db.curCrossOff = null;  // this value still saved in symbol object
        }
        break;
      case STATE_IN_PROB_SCALE:
        
        if (db.curProb.scalingBox != null && !leaveScale) {    // if the scaling box was selected, clear that out
          db.curProb.scalingBox.removeAllEventListeners();
          db.curContainer.removeChild(db.curProb.scalingBox);
          db.curProb.scalingBox = null;
        
        
          //cvGetFileDataToSave(); - undo stack?
        }
        break;
      case STATE_IN_IPAD_ABC:
        endABCText();
        break; 

    // other states will be added for specific symbol types
    default:
      break;
    }
      
    if (db.probState != STATE_ABC_WRAP && db.probState != STATE_DRAW_OVERLAY) {
      db.probState = STATE_NORMAL;
    }
    
  }
  doStageUpdate();
}


/***
 function cvControl is called by the sideboard UI when control bar keys are pressed
 It is the high level routine to manage the actions to process these keys
***/
export function cvControl(keyID) {

  //console.log("start control", keyID);
  // if a view only file then throw out everything except zoom in and out and view only change
  // - CHECK - maybe include pen tool switches
  if (db.state == STATE_VIEW_ONLY_FILE && keyID != symConst.CV_CNTL_END_VIEW_ONLY &&
    keyID != symConst.CV_CNTL_ZOOM_IN && keyID != symConst.CV_CNTL_ZOOM_OUT) {
      return;
    }
 
  // return out of any controls except zoom or new problem or A/AA done before any problem is entered
  if (db.state == STATE_INIT && keyID != symConst.CV_CNTL_ZOOM_IN && keyID != symConst.CV_CNTL_ZOOM_OUT
    && keyID != symConst.CV_CNTL_NEW_PROBLEM &&
    keyID != symConst.CV_CNTL_ENTER &&
    keyID != symConst.CV_CNTL_UNDO && keyID != symConst.CV_CNTL_REDO &&
    keyID != symConst.CV_CNTL_A && keyID != symConst.CV_CNTL_AA &&
    keyID != symConst.CV_CNTL_START_DRAW_TOOL  && keyID != symConst.CV_CNTL_END_DRAW_TOOL
    ) {

    return;
  }

  // ignore control characters during whitespace add, except for certain ones such as undo
  if (db.state == STATE_IN_WHITESPACE_ADD && 
      keyID != symConst.CV_CNTL_A && keyID !=  symConst.CV_CNTL_AA &&
      keyID != symConst.CV_CNTL_UNDO &&
      keyID != symConst.CV_CNTL_ZOOM_IN && keyID != symConst.CV_CNTL_ZOOM_OUT) {
        return;
    }

  if ((db.state == STATE_IN_DRAW_MULTI) && (db.curPenIndex > 0) && (db.penLayer != null)
      && db.pen != null && keyID != symConst.CV_CNTL_ZOOM_IN && keyID != symConst.CV_CNTL_ZOOM_OUT) {
    finishMultiLine();
    db.state = STATE_NORMAL;
  }

  // if in pen mode, ignore all control characters except undo, redo ,zoom, and pen controls
  if (db.inPen &&  keyID != symConst.CV_CNTL_UNDO && keyID!= symConst.CV_CNTL_REDO &&
    keyID != symConst.CV_CNTL_ZOOM_IN && keyID != symConst.CV_CNTL_ZOOM_OUT &&
    keyID != symConst.CV_CNTL_START_DRAW_TOOL && keyID != symConst.CV_CNTL_END_DRAW_TOOL &&
    keyID != symConst.CV_CNTL_WHITESPACE) {
         return;
    }

  // editing menu icon clicks can get passed in during ABC, so ignore those
  if (db.state == STATE_IN_ABC &&
    (keyID == symConst.CV_CNTL_DELETE_PROBLEM || keyID == symConst.CV_CNTL_WHITESPACE ||
    keyID == symConst.CV_CNTL_COPY || keyID == symConst.CV_CNTL_PASTE ||
    keyID == symConst.CV_CNTL_DUPLICATE_LINE || keyID == symConst.CV_CNTL_CLIPBOARD_SELECT)) {
      return;
    }

  if (db.state == STATE_IN_CLIPBOARD_SELECT  && 
      keyID != symConst.CV_CNTL_COPY && keyID != symConst.CV_CNTL_UNDO) {
    // clear only clipboard state and not problem state
    clearProbState(false,true);
  }
  if (db.userLog != null ) {
    let logInput = new CanvasInput(LOG_CNTR,keyID);
    db.userLog.input.push(logInput);
  }
  
  db.fileChanged = true;
  let noUndoPush = false;
  
  if (db.mathLevel == 4 && keyID  == symConst.CV_CNTL_NEW_GRID_PROBLEM) {
    keyID = symConst.CV_CNTL_NEW_PROBLEM;
  }

  
  switch (keyID) {
    case symConst.CV_CNTL_START_DRAW_TOOL:
      // If the user clicks pen icon while in an abc text box, finish the text box first
      if (db.state == STATE_IN_ABC) {
        handleTextBox();
      }
      hideCursor();
      startPen();
      break;
    case symConst.CV_CNTL_END_DRAW_TOOL:
      showCursor();
      disablePen();
      break;
    case symConst.CV_CNTL_UNDO:
      
      if (db.state == STATE_IN_ABC) {
        db.state = STATE_NORMAL;  
        db.fileChanged = true; 
        endABCText();
      }
      undoRedo();
      break;
    
    case symConst.CV_CNTL_REDO:
      // ignore redo clicks during an abc, since for sensible formating for this
      if (db.state != STATE_IN_ABC) {
        undoRedo(true);
      }
      break;

    case symConst.CV_CNTL_SET_VIEW_ONLY:
      //complete any abc boxes before switching to view only
      if (db.state == STATE_IN_ABC) {
        handleTextBox();
      }
      clearProbState(true, true);  // check these settings
      hideCursor();
      // Guard against null problem or grid shape while switching to view-only
      if (db.curProb && db.curProb.gridShape) {
        hideGridShape(db.curProb);
      }

      // cancel all the listeners for the entire stage
      //db.stageBackground.removeAllEventListeners();
      //for (let i = 0; i <= db.mProb.length-1; i++) {
      //  db.mProb[i].container.removeAllEventListeners();
      //  console.log("here");
      //}
      //stage.removeAllEventListeners();
      db.state = STATE_VIEW_ONLY_FILE;
      break;

    case symConst.CV_CNTL_END_VIEW_ONLY:
      db.state = STATE_NORMAL;
      
      showCursor();
      setLastProbActive();
      resetForChangeViewOnlyToEdit();
      break;

    case symConst.CV_CNTL_WHITESPACE:
      selectWhiteSpace();
      break;
    
    case symConst.CV_CNTL_CLIPBOARD_SELECT:
      if (db.state != STATE_NORMAL && db.displayType != DISPLAY_TYPE_TEXT) {
        clearProbState(true, true);
      }
      
      // call routine which is normally called by long timer for clipboard copy
      // ignore calls if in text problem or math cursor or is at end of line
      if ((db.curProb.displayType == DISPLAY_TYPE_GRID && (db.curLine.sIndex < db.curLine.sym.length-1)) ||
         ((db.curProb.displayType == DISPLAY_TYPE_LINE) && (db.curBranch.sIndex < db.curBranch.sym.length-1))) {
        copySelectTimer(null, true);
      }
      break;

    case symConst.CV_CNTL_FONT_INCREASE:

      db.fontIndex = Math.min(db.curProb.resizedIndex+1, FONT_INDEX_MAX);
      db.initSize(db.fontIndex);  
      db.curProb.resizedIndex = db.fontIndex;
      // resize the current problem, old ones stay the same
      resizeProbGridChange()
      break;

    case symConst.CV_CNTL_FONT_DECREASE:
    
    // set this like a font decrement for testing
      if (db.fontIndex > FONT_INDEX_MIN+1 && db.curProb.probScale > .4) {
        db.fontIndex = Math.max(db.curProb.resizedIndex-1, FONT_INDEX_MIN);
        db.initSize(db.fontIndex); 
        db.curProb.resizedIndex = db.fontIndex;
        resizeProbGridChange()
      }
      else {
        let noUndoPush = true;
      }
      break;
    case symConst.CV_CNTL_A:
      // is the "A" mode is chosen then only 1 digit is accepted on branch symbols of fraction,exp, sub (not roots)
      // and the app will add advances automatically
      db.isBranchAMode = true;  
      break;

    case symConst.CV_CNTL_AA:
      //displayIpadABC("Here is a test string");
      // is the "AA" mode is chosen then multiple digit is accepted on branch symbols of fraction,exp, sub (not roots)
      db.isBranchAMode = false;
      break;

    case symConst.CV_CNTL_NEW_GRID_PROBLEM:
      if (db.lev3UseGrid == false) {
        db.lev3UseGrid = true;
        db.displayType = DISPLAY_TYPE_GRID;
      }
      doNewProblem();
      break;

    case symConst.CV_CNTL_DELETE:
    case symConst.CV_CNTL_BACKSPACE:
      
      if (db.pIndex > -1 ) {    // skip calling delete if user has entered nothing and not clicked on canvas
        if (db.probState == STATE_IN_IPAD_ABC) {
          pressedKey(null,"",true);
        }
        else if (db.state == STATE_IN_ABC) {
          pressedKey(null,"",true);
        }
        else {
          if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
            deleteFromTree(keyID);
          }
          else {
            handleDeleteFromGrid(keyID);
          }
        }
      }
      break;
    case symConst.CV_CNTL_ARROWRIGHT:
      //displayIpadABC("Here is a test string");
      //let newUserPrefs = new UserPrefType();
      //newUserPrefs.colorEquals = true;
      //cvUserPrefs(newUserPrefs);
      //break;
     
    case symConst.CV_CNTL_ARROWLEFT:
    case symConst.CV_CNTL_ARROWUP:
    case symConst.CV_CNTL_ARROWDOWN:
      directionArrowMove(keyID);
      break;

    case symConst.CV_CNTL_ENTER: // a user enter press moves the problem to the next line

      if (db.curProb == null || db.state == STATE_INIT) {
        
        startMProb(db.displayType);
  
        db.state = STATE_NORMAL;
      }
    
      // check for if in a grid fraction, in which case treat this like an arrow to next area instead
      if (db.curProb.displayType == DISPLAY_TYPE_GRID && db.curProb.fracState != STATE_NORMAL) {
        if (db.curProb.fracState == STATE_IN_GRID_FRACTION_NUM) {
          
          cvControl(symConst.CV_CNTL_ARROWDOWN);
        }
        else {
          cvControl(symConst.CV_CNTL_ARROWRIGHT);
        }
      }
      else {
      
   
        let newLine;
        if (db.curProb.displayType != DISPLAY_TYPE_TEXT) {
          if (db.probState != STATE_NORMAL && db.probState != STATE_DRAW_OVERLAY) {
            clearProbState();
          }
          // Reset x,y positions, left aligned with problem start and next line
          if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
            db.ypos += db.curProb.gridH;

            // if inserting into middle of problem, then rest of problem down first
            if (db.curProb.lIndex < db.curProb.line.length-1) {

              moveYGridText(db.curProb, db.curProb.line.length-1, db.curProb.gridH,db.curProb.lIndex+1);
            }
          }
          // adjust ypos of line problems later
          
          db.xpos = db.mProb[db.pIndex].xpos;
          // create a new line element in the current problem
          // Increase the line Index in the current problem, and set curLine to the new line for easy reference
        

          if (db.displayType == DISPLAY_TYPE_GRID) {
            newLine = new MLineType();
            db.curProb.line.splice(db.curProb.lIndex+1,0,newLine);
            db.curLine = db.curProb.line[++db.curProb.lIndex];
          }
          else {
            newLine = new MBranchType();
            // if cursor at not at the start of a line, then add
            // the new line after the current one, which means increasind lIndex
            // if sIndex == -1, then new line goes before current one, and lIndex stays the same
            if (db.curLine.sIndex > -1 || db.curProb.lIndex > 0) {
              db.curProb.lIndex++;
            }
              
              // adjust the lineIDs of any following lines down, for use in mouse watcher to keep the
              // prior event handlers, which points to this line, to be in synch. 
            for (let k = db.curProb.lIndex; k <= db.curProb.line.length-1 ; k++) {
             
                db.curProb.line[k].lineID++;
            }
            db.curProb.line.splice(db.curProb.lIndex,0,newLine);
            
            db.curLine = db.curProb.line[db.curProb.lIndex];

          }
          //db.curProb.line.splice(db.curProb.lIndex+1,0,newLine);
        
          //db.curLine = db.curProb.line[++db.curProb.lIndex];

          if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
            // Line problems have each line in a separate container
            // create this container and switch db.curContainer to it

            db.curLine.lineID = db.curProb.lIndex;
          
            db.curLine.container = new createjs.Container();
            db.curLine.container.x = db.curLine.container.y = 0;
          
            db.curLine.bHeightBot = db.curProb.gridH; 
            db.curContainer.addChild(db.curLine.container);
            db.curBranch = db.curLine;
            resetMoveTreeProbHeight();
        
            //db.ypos = db.curProb.heightBelow + db.curProb.ypos - db.curProb.halfGH;
            //console.log(db.curProb.heightBelow,db.ypos);
            resetTreeXYPosAndCursor();
            drawProbShapes(Math.max(db.curProb.width+1,2),db.curProb.heightBelow); // fix for line types
          
          }
          else {
          //db.curLine = db.mProb[db.pIndex].line[++db.mProb[db.pIndex].lIndex];
          drawProbShapes(Math.max(db.curProb.width+1,2),db.curProb.line.length); // fix for line types
          drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
          }
        }
        // check if new line causes a page addition to be needed
        checkPosForPageAdd();
      }
      break;

    case symConst.CV_CNTL_NEW_PROBLEM: // user new problem starts a new problem at the coordinates 2 rows down from last problem

    

      // if this is the first thing a user does, then create a problem at the starting location
      //?

      if (db.state != STATE_INIT && db.mProb.length > 0) {
        clearProbState();
        // reset x,y position to be 2 lines down and to starting x position
        db.ypos += db.curProb.gridH * 2 * db.curProb.probScale;
        db.xpos = db.mProb[db.pIndex].container.x + (db.curProb.halfGW * db.curProb.probScale);
        checkPosForPageAdd()
      }

    // check if in level 3 and had been in grid mode, if so then switch back to default line mode  
    if (db.lev3UseGrid == true) {
      db.lev3UseGrid = false;
      db.displayType = DISPLAY_TYPE_LINE;
      // call sidebar here
    }
      doNewProblem(); 
    
      break;

    case symConst.CV_CNTL_COMPLETE:
  
      if (db.probState == STATE_CARRY_SYM) {
        clearProbState();
        if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
          db.xpos += db.curProb.gridW;
          db.curLine.sIndex++;
          drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
        }
        else {  // DISPLAY_TYPE_LINE
          // reset the xpos and ypos, and redraw cursor at right position based on curBranch
          db.curBranch.sIndex++;
          resetTreeXYPosAndCursor();
        }
      }
      else {
        if (db.displayType == DISPLAY_TYPE_LINE) {
          doControlComplete();
        }
        else {
          clearProbState();
        }
      }
      break;
    case symConst.CV_CNTL_ZOOM_IN:
      
        stage.scaleX = stage.scaleY = stage.scaleX * SCALE_INCREMENT;
        stage.canvas.width = stage.canvas.width * SCALE_INCREMENT;
        stage.canvas.height = stage.canvas.height * SCALE_INCREMENT;
        db.lastCanvasY = db.lastCanvasY * SCALE_INCREMENT;
        
      doStageUpdate();
      

      break;
    case symConst.CV_CNTL_ZOOM_OUT:
    
    // check against a minimum stage size, to prevent user from zoom out so far as to destroy the canvas (cause it's fun to zoom)
    if (stage.canvas.width > STAGE_MIN_WIDTH) {
     
        stage.scaleX = stage.scaleY = stage.scaleX / SCALE_INCREMENT;
        stage.canvas.width = stage.canvas.width / SCALE_INCREMENT;
        stage.canvas.height = stage.canvas.height / SCALE_INCREMENT;
        db.lastCanvasY = db.lastCanvasY / SCALE_INCREMENT;
        
      doStageUpdate();
    }
  
      break;

    // these symbols move the current branching problem to the next part
    case symConst.CV_CNTL_ADVANCE:
      doAdvance();
      break;

    case symConst.CV_CNTL_COPY:
      doClipboardCopy();
      break;

    case symConst.CV_CNTL_PASTE:
      doClipboardPaste();
      break;

    case symConst.CV_CNTL_DUPLICATE_LINE:
      duplicateLine();
      break;

    case symConst.CV_CNTL_DELETE_PROBLEM:
      if (db.pIndex > -1 ) {    // skip calling delete if user has entered nothing and not clicked on canvas
        // if within an abc, then just delete the text instead
         if (db.state == STATE_IN_ABC) {
            pressedKey(null,"",true,true);
        }
        else {
          deleteProb();
        }
      }
      break;  
    
    case symConst.CV_CNTL_PREV_PROB:
      changeToProb(keyID);
      break;
    
    case symConst.CV_CNTL_NEXT_PROB:
      changeToProb(keyID);
      break;

    default:
      break;
  }

  // create a record for the undo stack, as long as this isn't an enter or other open file action
  if (db.state != STATE_OPEN_FILE && !noUndoPush) {
    switch(keyID) {
      case symConst.CV_CNTL_UNDO:
      case symConst.CV_CNTL_REDO:
      case symConst.CV_CNTL_A:
      case symConst.CV_CNTL_AA:
      case symConst.CV_CNTL_WHITESPACE:
      case symConst.CV_CNTL_START_DRAW_TOOL:
      case symConst.CV_CNTL_END_DRAW_TOOL:
      case symConst.CV_CNTL_SET_VIEW_ONLY:
      case symConst.CV_CNTL_END_VIEW_ONLY:
      break;
      default:
        // check that this isn't a first action before any problems, and skip if it is
        if (db.mProb.length > 0) {
          // create an undo record for these 
          db.fileChanged = true;
          cvGetDataUndoPush();
        }
      break;
    }
  }
  //console.log("end control");
  
}

export function doNewProblem() {
// set the next problem to be after the last problem entered, to try to prevent
      // problems from overlapping
      let lastMatched = false;
      let lastpIndex = findLastProb();

      if (lastpIndex >= 0) {
        let lastProb = db.mProb[lastpIndex];
        lastMatched = lastProb.matchLevel;
        // create a new math problem
        // first move x,y pos to start of last line
        if (lastProb.displayType == DISPLAY_TYPE_GRID) {
          //add two gridH plus height of problem
          db.ypos = lastProb.ypos + (lastProb.line.length-1)*lastProb.gridH+2*lastProb.gridH;
        }
        else if (lastProb.displayType == DISPLAY_TYPE_LINE) {
          db.ypos = lastProb.ypos + lastProb.heightBelow+lastProb.gridH;
        }
        else {
          let textHeight = (db.curText != null) ? db.curText.h : lastProb.gridH;
          db.ypos = lastProb.ypos + textHeight + lastProb.gridH;
          db.displayType = (db.mathLevel == 1 || db.mathLevel ==2) ? DISPLAY_TYPE_GRID : DISPLAY_TYPE_LINE;
        }
      }
      if (!lastMatched) {
        let lastMatch = findLastMatchedProb();
        if (lastMatch >= 0) {
          db.displayType = lastMatch.displayType;
        }
        else {  // if in changed level file with no matched then use mathlevel to decide problem type
          db.displayType = (db.mathLevel == 1 || db.mathLevel ==2) ? DISPLAY_TYPE_GRID : DISPLAY_TYPE_LINE;
        }
      }

      startMProb(db.displayType);
      
    }
function duplicateLine() {

  // duplicate line isn't supported on text problems, since they can't have multiple lines
  if (db.curProb.displayType == DISPLAY_TYPE_TEXT) {
    return;
  }

  let mathFile;
  let saveIndex = db.curLine.sIndex;
  let saveXpos = db.xpos;

  // first use the segment of file copy, to create a save file for just this line
  db.curLine.sIndex = -1;
  mathFile = saveForCopyDuplicate(db.curLine,0, db.curLine.sym.length);
  // then need to prevent passing cvControl an sIndex of -1 for lines, to prevent creating line before this one
  if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
    db.curLine.sIndex = 0;  // this isn't used before getting reset, except for cvControl checking it's not -1
  }

  db.state = STATE_OPEN_FILE;
  cvControl(symConst.CV_CNTL_ENTER);

  let mFileProb = mathFile.mathProblem[0];
  
  // use file open segment to draw new line
  // switch to state_in_paste to avoid copying line segments
  let tempState = db.probState;
  db.probState = STATE_IN_PASTE;
  drawFromSaveFile(mathFile,mFileProb); 
  db.probState = tempState;
  db.state = STATE_NORMAL;

  // set cursor position to sIndex of copied line main line
  db.curLine.sIndex = saveIndex;
  if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
    db.xpos = saveXpos; // db.curProb.xpos + (saveIndex+1)*db.curProb.gridW; 
    drawCursor(db.xpos-db.curProb.halfGW,db.ypos-db.curProb.halfGH);
  }
  else {
    resetTreeXYPosAndCursor();
    drawProbShapes(db.curLine.lineWidth, db.curProb.heightAbove+db.curProb.heightBelow);
  }

}

/**
 * function doClipBoardCopy will copy what is selected within db.selectionArea, and copy that piece of
 * the problem into one problem of a save file format. - This is then used for paste operations
 */

export function doClipboardCopy() {

  let line, startSIndex, endSIndex,startX, endX;
  

  if (db.selectionArea != null && db.selectionArea.width != 0) {

    // process a copy for a line type problem
    if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
      line = db.selectionArea.curBranch;

      // adjust the position to use based on which line/branch container has symbols - selection area highlight
      // always stays in coordinates of starting branch
      // selectionArea startX and endX show location of symbols within selected brach to select
      if (db.selectionArea.curBranch == db.selectionArea.startBranch) {
        startX = db.selectionArea.startX;
        endX = db.selectionArea.endX;
      }
      // if user selectred into the main line but started in the branch within this line, adjust this way
      // I don't actually understand why localToLocal needs to be set different for nested branches, but it's what works
      else if (db.selectionArea.curBranch == db.selectionArea.startBranch.parent ) {
        // if nested branch, need different calculations due to container.x positions

        let point;
        if (db.selectionArea.curBranch.isBranch) {

          point = db.selectionArea.startBranch.container.localToLocal(db.selectionArea.startX/(db.curProb.probScale),
                                                0, db.curBranch.container);
          startX = point.x;
          point = db.selectionArea.startBranch.container.localToLocal(db.selectionArea.endX/(db.curProb.probScale),
                                                0, db.curBranch.container);
          endX = point.x;
        }
        else {
          point = db.selectionArea.startBranch.container.localToLocal(db.selectionArea.startX/(db.curProb.probScale),
                                                0, db.curBranch.container);
          startX = point.x;
          point = db.selectionArea.startBranch.container.localToLocal(db.selectionArea.endX/(db.curProb.probScale),
                                                0, db.curBranch.container);
          endX = point.x;

        }
        //console.log("check point", startX,db.curBranch.container.x);
        //if (db.curBranch.isBranch) {
        //  startX = db.selectionArea.startX - db.selectionArea.startBranch.container.x+db.selectionArea.curBranch.container.x;
        //  endX = db.selectionArea.endX - db.selectionArea.startBranch.container.x+db.selectionArea.curBranch.container.x;
       // }
        //else {
        //  startX = db.selectionArea.startX + db.selectionArea.startBranch.container.x;
        //  endX = db.selectionArea.endX + db.selectionArea.startBranch.container.x;
        //}
        //if moved to within another branch, need to add back the offset to that branch
        //if (db.selectionArea.curBranch.isBranch) {
        //  startX += line.container.x;
        //  endX += line.container.x;
        //}
      }
     
      // locate which symbol corresponds to this location, by tallying the widths of symbols in this branch
      startSIndex = findBranchClickIndex(startX/(db.curProb.gridW*db.curProb.probScale));
      endSIndex = findBranchClickIndex(endX/(db.curProb.gridW*db.curProb.probScale));
      //console.log(db.selectionArea, startSIndex, endSIndex, db.curBranch, startX, endX);
      //console.log(startSIndex, endSIndex);
      //check if last symbol is actually selected for copy - if it was under a third of the width under the selection area it
      // will not be, and should be excluded
      if (!db.selectionArea.curBranch.sym[endSIndex].isSelected) {
        endSIndex--;
       }
    }
    else if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
      // if in grid problem, then can calculate the selected symbol based on grid width
      line = db.curLine;
      startSIndex = Math.trunc(db.selectionArea.startX/db.curProb.gridW);
      endSIndex = Math.trunc(((db.selectionArea.startX + db.selectionArea.width)/db.curProb.gridW)+.7);
      //console.log(startSIndex, endSIndex,(db.selectionArea.startX + db.selectionArea.width)/db.curProb.gridW )
    }
    else {
      line = db.curLine;
      startSIndex =  -1;
      endSIndex = 0;
    }

    // check index is within range of branch
    if (startSIndex <= line.sym.length-1) {
      let mathFile;
      
      // and copy to a math file structure the symbols within that index range
      mathFile = saveForCopyDuplicate(line,startSIndex, endSIndex);
      db.clipboard = mathFile;
    }
  }
  // clear the selection areas and state
  clearProbState();
}

/**
 * function doClipboardPaste
 * draw the symbols contained in the clipboard math save file through replicating a file open
 * for that section of a problem
 */

function doClipboardPaste() {

    
  if (db.clipboard != null) {
    db.state = STATE_OPEN_FILE;
    let mFileProb = db.clipboard.mathProblem[0];
    //console.log(mFileProb);
    let tempState = db.probState;
    db.probState = STATE_IN_PASTE;
    drawFromSaveFile(db.clipboard,mFileProb); 
    db.state = STATE_NORMAL;
    db.probState = tempState;

    // redraw problem shapes at end of paste, since weren't drawn before due to state set to open file
    if (db.curProb.displayType == DISPLAY_TYPE_GRID) {
      drawProbShapes(Math.max(db.curProb.width+1,2),db.curProb.line.length);
    }
    else if (db.curProb.displayType == DISPLAY_TYPE_LINE) {
      // width and height area calculated in drawProbShapes for line problems
      drawProbShapes(0,0,true);

    }
  }
  
}

export function checkPosForPageAdd() {
  
  // don't add page breaks on a file open
  if (db.state != STATE_OPEN_FILE) {
    
    // create new page at 100 pixels less than the end of the page
    if (db.ypos > stage.canvas.height-100) {
      
      drawPageBreakLine(db.pageCount*ONE_PAGE_LENGTH);
      db.pageCount++;
      stage.canvas.height += 1123 * stage.scaleX;
      db.lastCanvasY = db.ypos; 
      setStageBackground();
      if (db.penBackground != null) {
        resizePenBackground();
      }
      handleStageMouse();
    }
  }
}

// Check drawn symbols given with ABC  types to see if control key types
// redirect to cvControl or ignore them depending on key entered
function checkKeyboardCntl(keyID) {
  switch (keyID) {
    case symConst.KEYBOARD_ENTER:
    
      // treat enters from keyboards within branches as returns
      if (db.curProb.displayType == DISPLAY_TYPE_LINE && db.curBranch.isBranch) {
        cvControl(symConst.CV_CNTL_COMPLETE);
      }
      else {
        cvControl(symConst.CV_CNTL_ENTER);
      }
      break;
    case symConst.KEYBOARD_TAB:
      draw(symConst.KEY_ID_TAB,symConst.CV_SIMPLE_GRP,symConst.CV_SPECIAL_TYPE);
      break;
    case symConst.KEYBOARD_BACKSPACE:
      cvControl(symConst.CV_CNTL_BACKSPACE);
      break;
    case symConst.KEYBOARD_DELETE:
      cvControl(symConst.CV_CNTL_DELETE);
      break;
    case symConst.KEYBOARD_ARROWRIGHT:
    case symConst.KEYBOARD_ARROWLEFT:
    case symConst.KEYBOARD_ARROWUP:
    case symConst.KEYBOARD_ARROWDOWN:
      directionArrowMove(keyID);
      break;
    case symConst.KEYBOARD_INSERT:
      //add call to insert support routine here
      break;
    default:
      // other keyboard control-type keys should be ignored if passed in, ie tab, alt, pdDn, etc.
      break;
  }
}



export function resetScale(scaleX, scaleY, width, height) {
  stage.scaleX = scaleX;
  stage.scaleY = scaleY;
  stage.canvas.width = width;
  stage.canvas.height = height;
  doStageUpdate();
}
